
export const formatAddress = (address: any): string => {
  let shortAddress = address.street;
  shortAddress += address.street_line_two ? address.street_line_two : '';
  shortAddress += ', ';
  shortAddress += `${address.city}, ${address.state} ${address.zipcode}`;

  return shortAddress;
};
